/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompetitionType } from './CompetitionType';
import {
    CompetitionTypeFromJSON,
    CompetitionTypeFromJSONTyped,
    CompetitionTypeToJSON,
    CompetitionTypeToJSONTyped,
} from './CompetitionType';
import type { SurfaceCompetitionGame } from './SurfaceCompetitionGame';
import {
    SurfaceCompetitionGameFromJSON,
    SurfaceCompetitionGameFromJSONTyped,
    SurfaceCompetitionGameToJSON,
    SurfaceCompetitionGameToJSONTyped,
} from './SurfaceCompetitionGame';
import type { SurfaceCompetitionPrizePool } from './SurfaceCompetitionPrizePool';
import {
    SurfaceCompetitionPrizePoolFromJSON,
    SurfaceCompetitionPrizePoolFromJSONTyped,
    SurfaceCompetitionPrizePoolToJSON,
    SurfaceCompetitionPrizePoolToJSONTyped,
} from './SurfaceCompetitionPrizePool';

/**
 * 
 * @export
 * @interface SurfaceCompetitionResponse
 */
export interface SurfaceCompetitionResponse {
    /**
     * 
     * @type {string}
     * @memberof SurfaceCompetitionResponse
     */
    id: string;
    /**
     * 
     * @type {CompetitionType}
     * @memberof SurfaceCompetitionResponse
     */
    type: CompetitionType;
    /**
     * 
     * @type {string}
     * @memberof SurfaceCompetitionResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceCompetitionResponse
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceCompetitionResponse
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceCompetitionResponse
     */
    division?: string;
    /**
     * 
     * @type {number}
     * @memberof SurfaceCompetitionResponse
     */
    order?: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceCompetitionResponse
     */
    competitionId?: string;
    /**
     * 
     * @type {SurfaceCompetitionGame}
     * @memberof SurfaceCompetitionResponse
     */
    game?: SurfaceCompetitionGame;
    /**
     * 
     * @type {number}
     * @memberof SurfaceCompetitionResponse
     */
    participantCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceCompetitionResponse
     */
    maxParticipants?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceCompetitionResponse
     */
    teamSize?: number;
    /**
     * 
     * @type {SurfaceCompetitionPrizePool}
     * @memberof SurfaceCompetitionResponse
     */
    prizePool?: SurfaceCompetitionPrizePool;
    /**
     * 
     * @type {number}
     * @memberof SurfaceCompetitionResponse
     */
    startDate?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceCompetitionResponse
     */
    endDate?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceCompetitionResponse
     */
    registrationEndDate?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceCompetitionResponse
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceCompetitionResponse
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceCompetitionResponse
     */
    structure?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceCompetitionResponse
     */
    entryType?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceCompetitionResponse
     */
    timingMode?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceCompetitionResponse
     */
    hostType?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceCompetitionResponse
     */
    creatorId?: string;
}



/**
 * Check if a given object implements the SurfaceCompetitionResponse interface.
 */
export function instanceOfSurfaceCompetitionResponse(value: object): value is SurfaceCompetitionResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function SurfaceCompetitionResponseFromJSON(json: any): SurfaceCompetitionResponse {
    return SurfaceCompetitionResponseFromJSONTyped(json, false);
}

export function SurfaceCompetitionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceCompetitionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': CompetitionTypeFromJSON(json['type']),
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'status': json['status'],
        'division': json['division'] == null ? undefined : json['division'],
        'order': json['order'] == null ? undefined : json['order'],
        'competitionId': json['competitionId'] == null ? undefined : json['competitionId'],
        'game': json['game'] == null ? undefined : SurfaceCompetitionGameFromJSON(json['game']),
        'participantCount': json['participantCount'] == null ? undefined : json['participantCount'],
        'maxParticipants': json['maxParticipants'] == null ? undefined : json['maxParticipants'],
        'teamSize': json['teamSize'] == null ? undefined : json['teamSize'],
        'prizePool': json['prizePool'] == null ? undefined : SurfaceCompetitionPrizePoolFromJSON(json['prizePool']),
        'startDate': json['startDate'] == null ? undefined : json['startDate'],
        'endDate': json['endDate'] == null ? undefined : json['endDate'],
        'registrationEndDate': json['registrationEndDate'] == null ? undefined : json['registrationEndDate'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'structure': json['structure'] == null ? undefined : json['structure'],
        'entryType': json['entryType'] == null ? undefined : json['entryType'],
        'timingMode': json['timingMode'] == null ? undefined : json['timingMode'],
        'hostType': json['hostType'] == null ? undefined : json['hostType'],
        'creatorId': json['creatorId'] == null ? undefined : json['creatorId'],
    };
}

export function SurfaceCompetitionResponseToJSON(json: any): SurfaceCompetitionResponse {
    return SurfaceCompetitionResponseToJSONTyped(json, false);
}

export function SurfaceCompetitionResponseToJSONTyped(value?: SurfaceCompetitionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': CompetitionTypeToJSON(value['type']),
        'name': value['name'],
        'description': value['description'],
        'status': value['status'],
        'division': value['division'],
        'order': value['order'],
        'competitionId': value['competitionId'],
        'game': SurfaceCompetitionGameToJSON(value['game']),
        'participantCount': value['participantCount'],
        'maxParticipants': value['maxParticipants'],
        'teamSize': value['teamSize'],
        'prizePool': SurfaceCompetitionPrizePoolToJSON(value['prizePool']),
        'startDate': value['startDate'],
        'endDate': value['endDate'],
        'registrationEndDate': value['registrationEndDate'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'structure': value['structure'],
        'entryType': value['entryType'],
        'timingMode': value['timingMode'],
        'hostType': value['hostType'],
        'creatorId': value['creatorId'],
    };
}

